import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {ButtonItem} from 'devextreme-react/form';


export default class FormButtonItem extends Component {
    render() {
        return <ButtonItem
            {...omit(['loading_state', 'setProps', 'children'], this.props)}
        />
    }
}

FormButtonItem.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Configures the button
     */
    buttonOptions: PropTypes.object,
    /**
     * Specifies how many columns the item spans
     */
    colSpan: PropTypes.number,
    /**
     * Specifies a CSS class to be applied to the item
     */
    cssClass: PropTypes.string,
    /**
     * Specifies the button's horizontal alignment
     */
    horizontalAlignment: PropTypes.oneOf(['center', 'left', 'right']),
    /**
     * Specifies the item's type. Set it to "button" to create a button item.
     */
    itemType: PropTypes.oneOf(['empty', 'group', 'simple', 'tabbed', 'button']),
    /**
     * Specifies a name that identifies the form item
     */
    name: PropTypes.string,
    /**
     * Specifies the button's vertical alignment
     */
    verticalAlignment: PropTypes.oneOf(['bottom', 'center', 'top']),
    /**
     * Specifies whether the item is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the sequence number of the item in a form, group or tab
     */
    visibleIndex: PropTypes.number,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

FormButtonItem.defaultProps = {
    // buttonOptions: undefined,
    // colSpan: undefined,
    // cssClass: undefined,
    horizontalAlignment: 'right',
    itemType: 'simple',
    // name: undefined,
    verticalAlignment: 'top',
    visible: true,
    // visibleIndex: undefined
};
